import { cell_t, project_t, task_t } from '../logic/types';

const listOfSitesSupported = [
    'amazon',
    'americanas',
    'belezenaweb',
    'bestbuy',
    'biccamera',
    'currys',
    'fnac',
    'harveynorman',
    'jbhifi',
    'jd',
    'kroger',
    'liverpool',
    'lookfantastic',
    'magazineluiza',
    'mediamarkt',
    'meijer',
    'target',
    'walmart',
    'carrefour',
    'esselunga',
    'instacart',
    'boulanger',
    'leclercdrive',
    'tehnomanija',
    'gigatron',
    'hillspet',
    'royalcanin',
    'tesco',
    'asda',
    'ocado',
    'boots',
    'walgreens',
    'qvc',
];

export function isProjectValid(project: project_t) {
    //* validate other props of project
    return !!!project.cells.find((cell) => validateCell(cell) === false);
}

export function isCellValid(cell: cell_t | undefined) {
    if (!cell) return;

    return validateCell(cell);
}

function validateCell(cell: cell_t) {
    if (!cell.name || !cell.next_url) {
        return false;
    }

    if (Number(cell.time) < 0) {
        return false;
    }

    if (cell.tasks.find((task) => validateTask(task) === false)) {
        return false;
    }

    return true;
}
/**
 * Checks is string a valid URL address
 * @param {String} string
 * @returns {Boolean}
 */
export const isValidHttpUrl = (string: string, http = false) => {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    if (http) {
        return url.protocol === 'http:' || url.protocol === 'https:';
    }

    return url.protocol === 'https:';
};

const isURLInListOfSupportedSites = (domain: string) => domain.split('.').find((part) => listOfSitesSupported.find((site) => site === part));

export const validateTaskWithErrorMSG = (task: task_t) => {
    const errors: any = {
        urlCheck: {},
    };
    if (task.name === '') {
        errors.name = 'Name is required';
    }

    const hostname = new URL(task.url).hostname;
    const domain = hostname.indexOf('www.') > -1 ? hostname.split('www.')[1] : hostname;

    if (!task.ssMode) {
        task.urlCheck.forEach((urlCheck, i) => {
            if (!isURLInListOfSupportedSites(urlCheck)) {
                errors.urlCheck[i] = 'Url check must be part of url';
            }
        });
    }
    // if (task.url.indexOf(task.urlCheck[0]) === -1) {
    //     errors.urlCheck = 'Url check must be part of url';
    // }
    if (!isValidHttpUrl(task.url)) {
        errors.url = 'URL must be valid url with https protocol';
    }

    if (!task.ssMode && !isURLInListOfSupportedSites(domain)) {
        errors.url = 'URL is not in list of supported sites, please turn on screenshot mode!';
    }

    return errors;
};

function validateTask(task: task_t) {
    if (!task.name || !task.url || task.urlCheck.filter((url) => url !== '').length === 0) {
        return false;
    }

    if (!isValidHttpUrl(task.url)) {
        return false;
    }

    const hostname = new URL(task.url).hostname;
    const domain = hostname.indexOf('www.') > -1 ? hostname.split('www.')[1] : hostname;

    if (!task.ssMode && !isURLInListOfSupportedSites(domain)) {
        return false;
    }

    if (!task.ssMode) {
        task.urlCheck.forEach((urlCheck, i) => {
            if (!isURLInListOfSupportedSites(urlCheck)) {
                return false;
            }
        });
    }

    // if (task.urlCheck.find((urlCheck) => task.url.indexOf(urlCheck) === -1)) {
    //     return false;
    // }

    return true;
}
